// // // import React, { useState } from "react";
// // // import "./Otp.css";
// // // import { useLocation, useNavigate } from "react-router-dom";

// // // const Otp = () => {

// // //   const navigate = useNavigate();

// // //   const location = useLocation();

// // //   const [otp, setOtp] = useState("");

// // //   const data = location.state?.data;

// // //   const verify = () => {
// // //     if (data.OTP === otp) {
// // //       console.log("hellooooo")
// // //       navigate("/");
// // //     }
// // //   };

// // //   return (
// // //     <div className="otp">
// // //       <div id="otp_text" className="otp_container">
// // //         <h5>Otp</h5>

// // //         <div className="Otp_input_container">
// // //           {/* <input name='otp' onChange={setOtp((e)=> e.target.value)} maxLength={1}  type="tel" /><input name='otp' onChange={setOtp((e)=> e.target.value) } maxLength={1} type="tel" /><input name='otp' onChange={setOtp((e)=> e.target.value) } maxLength={1} type="tel" /><input name='otp' onChange={setOtp((e)=> e.target.value) } maxLength={1} type="tel" /><input name='otp' onChange={setOtp((e)=> e.target.value) } maxLength={1} type="tel" /><input name='otp' onChange={setOtp((e)=> e.target.value) } maxLength={1} type="tel" /> */}

// // //           <input
// // //             name="otp"
// // //             onChange={(e) => setOtp((prevOtp) => prevOtp + e.target.value)}
// // //             maxLength={1}
// // //             type="tel"
// // //           />
// // //           <input
// // //             name="otp"
// // //             onChange={(e) => setOtp((prevOtp) => prevOtp + e.target.value)}
// // //             maxLength={1}
// // //             type="tel"
// // //           />
// // //           <input
// // //             name="otp"
// // //             onChange={(e) => setOtp((prevOtp) => prevOtp + e.target.value)}
// // //             maxLength={1}
// // //             type="tel"
// // //           />
// // //           <input
// // //             name="otp"
// // //             onChange={(e) => setOtp((prevOtp) => prevOtp + e.target.value)}
// // //             maxLength={1}
// // //             type="tel"
// // //           />
// // //           <input
// // //             name="otp"
// // //             onChange={(e) => setOtp((prevOtp) => prevOtp + e.target.value)}
// // //             maxLength={1}
// // //             type="tel"
// // //           />
// // //           <input
// // //             name="otp"
// // //             onChange={(e) => setOtp((prevOtp) => prevOtp + e.target.value)}
// // //             maxLength={1}
// // //             type="tel"
// // //           />
// // //         </div>

// // //         <button onClick={verify} className="verify_btn">
// // //           Verify
// // //         </button>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default Otp;

// // import React, { useState, useRef } from "react";
// // import "./Otp.css";
// // import { useLocation, useNavigate } from "react-router-dom";

// // const Otp = () => {
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const [otp, setOtp] = useState("");

// //   const data = location.state?.data;

// //   // Create refs for each input field
// //   const inputRefs = Array.from({ length: 6 }, () => useRef(null));

// //   const handleChange = (e, index) => {
// //     const { value } = e.target;
// //     if (/^\d$/.test(value)) {
// //       // Update OTP state
// //       const newOtp = otp.split('');
// //       newOtp[index] = value;
// //       setOtp(newOtp.join(''));

// //       // Move focus to the next input field if not the last one
// //       if (index < inputRefs.length - 1) {
// //         inputRefs[index + 1].current.focus();
// //       }
// //     } else {
// //       // Handle cases where the input is invalid (e.g., non-digit)
// //       e.target.value = "";
// //     }
// //   };

// //   const verify = () => {
// //     if (data.OTP === otp) {
// //       console.log("hellooooo");
// //       navigate("/");
// //     } else {
// //       console.log("Invalid OTP");
// //     }
// //   };

// //   return (
// //     <div className="otp">
// //       <div id="otp_text" className="otp_container">
// //         <h5>Otp</h5>

// //         <div className="Otp_input_container">
// //           {inputRefs.map((ref, index) => (
// //             <input
// //               key={index}
// //               name="otp"
// //               ref={ref}
// //               onChange={(e) => handleChange(e, index)}
// //               maxLength={1}
// //               type="tel"
// //               autoFocus={index === 0} // Focus the first input by default
// //             />
// //           ))}
// //         </div>

// //         <button onClick={verify} className="verify_btn">
// //           Verify
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Otp;

// import React, { useState, useRef } from "react";
// import "./Otp.css";
// import { useLocation, useNavigate } from "react-router-dom";

// const Otp = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [otp, setOtp] = useState("");

//   const data = location.state?.data;

//   // Initialize refs for each input field
//   const inputRefs = [
//     useRef(null),
//     useRef(null),
//     useRef(null),
//     useRef(null),
//     useRef(null),
//     useRef(null),
//   ];

//   const handleChange = (e, index) => {
//     const { value } = e.target;
//     if (/^\d$/.test(value)) {
//       // Update OTP state
//       const newOtp = otp.split("");
//       newOtp[index] = value;
//       setOtp(newOtp.join(""));

//       // Move focus to the next input field if not the last one
//       if (index < inputRefs.length - 1) {
//         inputRefs[index + 1].current.focus();
//       }
//     } else {
//       // Handle cases where the input is invalid (e.g., non-digit)
//       e.target.value = "";
//     }
//   };

//   const verify = () => {

//     if( otp=== "") {
//      return alert("Please enter your Otp");
//     }

//     if (data.OTP === otp) {
//       console.log("hellooooo");
//       navigate("/admin");
//     } else {
//       console.log("Invalid OTP");
//       alert("Pls enter valid Otp");
//     }
//   };

//   return (
//     <div className="otp">
//       <div id="otp_text" className="otp_container">
//         <h5>Otp Verification</h5>

//         <div className="Otp_input_container">
//           {inputRefs.map((ref, index) => (
//             <input
//               key={index}
//               name="otp"
//               ref={ref}
//               onChange={(e) => handleChange(e, index)}
//               maxLength={1}
//               type="tel"
//               autoFocus={index === 0} // Focus the first input by default
//             />
//           ))}
//         </div>

//         <button onClick={verify} className="verify_btn">
//           Verify
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Otp;

import React, { useState, useRef } from "react";
import "./Otp.css";
import { useLocation, useNavigate } from "react-router-dom";

const Otp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [otp, setOtp] = useState("");

  const data = location.state?.data;

  // Initialize refs for each input field at the top level
  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^\d$/.test(value)) {
      // Update OTP state
      const newOtp = otp.split("");
      newOtp[index] = value;
      setOtp(newOtp.join(""));

      // Move focus to the next input field if not the last one
      if (index < inputRefs.length - 1) {
        inputRefs[index + 1].current.focus();
      }
    } else {
      // Handle cases where the input is invalid (e.g., non-digit)
      e.target.value = "";
    }
  };

  const verify = () => {
    if (otp === "") {
      return alert("Please enter your Otp");
    }

    if (data.OTP === otp) {
      console.log("hellooooo");
      navigate("/admin");
    } else {
      console.log("Invalid OTP");
      alert("Please enter a valid Otp");
    }
  };

  return (
    <div className="otp">
      <div id="otp_text" className="otp_container">
        <h5>Otp Verification</h5>

        <div className="Otp_input_container">
          {inputRefs.map((ref, index) => (
            <input
              key={index}
              name="otp"
              ref={ref}
              onChange={(e) => handleChange(e, index)}
              maxLength={1}
              type="tel"
              autoFocus={index === 0} // Focus the first input by default
            />
          ))}
        </div>

        <button onClick={verify} className="verify_btn">
          Verify
        </button>
      </div>
    </div>
  );
};

export default Otp;
